<template>
  <div id="dashboard-manager">
    <div class="filter-entities" v-if="needEntitySelect">
      <select-entity :entities="entityAll"
                     :isDashboard="true"
                     :entitySelector="'entity_id_in'"
                     :colLabel="'col-md-2'"
                     :colSelect="'col-md-10 col-lg-3'"
                     marginEntity="justify-content-center"
                     :preselectedEntityId="filters.entity_id_in"
                     @entity-changed="changeFilterEntity"/>
    </div>
    <div class="action-bar">
      <Menu :entityId="selectedEntityId" :entity="entity"></Menu>
      <div class="clearfix"></div>
    </div>
    <div class="home-blocks">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <upcoming-block :entityId="selectedEntityId"></upcoming-block>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <awaiting-candidate-block :currentUser='currentUser' :entityId="selectedEntityId"></awaiting-candidate-block>
        </div>
        <div class="col-lg-4 col-md-12 col-sm-12">
          <information-block :currentUser='currentUser' :entityId="filters.entity_id_in"></information-block>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Menu from './manager/Menu'
import UpcomingBlock from './manager/UpcomingBlock'
import AwaitingCandidateBlock from "./manager/AwaitingCandidateBlock";
import InformationBlock from "./manager/InformationBlock";
import SelectEntity from '@/components/common/SelectEntity'

export default {
  name: "DashboardManager",
  data: function() {
    return {
      entity: {},
      filters: {
        entity_id_in: null
      }
    }
  },
  components: {
    Menu,
    UpcomingBlock,
    AwaitingCandidateBlock,
    InformationBlock,
    SelectEntity
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
      entitiesOptions: 'users/manageableEntities',
      isSingleEntity: 'users/isSingleEntity',
    }),
    entityAll() {
      var entities = [{ id: null, name: this.$i18n.t('models.resource_types.all') }]
      return entities.concat(this.entitiesOptions)
    },
    selectedEntityId() {
      if (this.isSingleEntity) {
        return this.entitiesOptions[0].id
      }

      return this.filters.entity_id_in
    },
    needEntitySelect() {
      return this.entitiesOptions.length > 0 && !this.isSingleEntity
    }
  },
  beforeMount: function(){
    let content = document.querySelector('.content');
    if (content) {
      content.classList.add("homepage");
    }
  },
  beforeDestroy: function(){
    let content = document.querySelector('.content');
    if (content) {
      content.classList.remove("homepage");
    }
  },
  methods: {
    changeFilterEntity(value) {
      this.entity = value
      this.addFilter(value.id, 'entity_id_in')
    },
    addFilter: function(value, id){
      let filters = Object.assign({}, this.filters);
      filters[id] = value;
      this.filters = filters;
    }
  },
  mounted() {
    this.$store.dispatch('users/initManageableOptions');
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Manager.vue